<template>
  <form action="" class="proxy_apply login_same d-grid h-100 mb-0" autocomplete="off">
    <div class="login_wrap">
      <div class="login_toplogo d-flex align-items-center justify-content-between">
        <router-link to="/agent">
          <a class="btn btn_back d-flex rounded-circle border-0" href="#"><i class="icon-keyboard_arrow_left" /></a>
        </router-link>
        <img class="img_logo d-flex mw-100" :src="$store.getters.brand.image" height="50" alt="">
      </div>
      <div class="login_inner">
        <h5 class="login_title">
          {{ $t("Bao.new_member") }}{{ $t("Bao.apply_for_agent") }}
        </h5>
        <div class="login_form bank_area">
          <div class="form-group">
            <label class="form_lab"><b>{{ $t("Bao.apply_agent_input_contract") }}</b></label>
            <span class="position-relative">
              <select v-model="contactForm.type" v-validate="'required'" class="account_form_slt w-100">
                <option value="">
                  {{ $t("Bao.apply_agent_choose_contract") }}
                </option>
                <option v-for="(item, key) in contactTypes" :key="key" :value="key">
                  {{ item }}
                </option>
              </select>
              <small class="help-block d-none">{{ $t("Bao.input_is_necessary") }}</small>
            </span>
          </div>
          <div class="form-group">
            <span class="position-relative">
              <input
                v-model="contactForm.name"
                v-validate="'required'"
                class="account_form_ipt text-center w-100"
                :placeholder="$t('Bao.please_input')+(contactTypes[contactForm.type] == undefined ? '' : contactTypes[contactForm.type]) "
                name="contactName"
                :required="true"
                autocomplete="off"
              >
              <small v-if="errors.has('contactName')" class="help-block">{{ $t("Bao.input_is_necessary") }}</small>
            </span>
          </div>
          <div class="form-group">
            <label class="form_lab">
              <b>{{ $t('Bao.please_input') + $t("Bao.username") }}</b>
            </label>
            <input
              v-model="postForm.username"
              v-validate="'required'"
              class="account_form_ipt text-center w-100"
              :placeholder="$t('Bao.member_username_limit')"
              type="text"
              name="username"
              :data-vv-as="$t('Bao.username')"
              autocomplete="off"
            >
            <small v-if="errors.has('username')" class="help-block">{{ errors.first('username') }}</small>
          </div>
          <div class="form-group">
            <label class="form_lab">
              <b>{{ $t('Bao.please_input') + $t("Bao.password") }}</b>
            </label>
            <input
              v-model="postForm.newPassword"
              v-validate="'required'"
              class="account_form_ipt text-center w-100"
              :placeholder="$t('Bao.password_notice')"
              :type="fieldTypes.newPassword"
              name="newPassword"
              :data-vv-as="$t('Bao.password')"
              autocomplete="off"
              @focus="handleType"
              @blur="handleType"
            >
            <small v-if="errors.has('newPassword')" class="help-block">{{ errors.first('newPassword') }}</small>
          </div>
          <div class="form-group">
            <label class="form_lab">{{ $t('Bao.confirmPassword') }}</label>
            <input
              v-model="postForm.confirmPassword"
              v-validate="'required'"
              class="account_form_ipt text-center w-100"
              :placeholder="$t('Bao.confirm_pass')"
              :type="fieldTypes.confirmPassword"
              name="confirmPassword"
              :data-vv-as="$t('Bao.confirmPassword')"
              autocomplete="off"
              @focus="handleType"
              @blur="handleType"
            >
            <small v-if="errors.has('confirmPassword')" class="help-block">{{ errors.first('confirmPassword') }}</small>
          </div>
          <div v-if="$store.getters.permissionInfo.register_need_phone == 1" class="form-group">
            <label class="form_lab">
              <b>{{ $t('Bao.please_input') + $t("Bao.phone") }}</b>
            </label>
            <vue-tel-input
              v-model="postForm.phone"
              v-validate="'required'"
              class="form_ipt_tel"
              :placeholder="$t('Bao.please_input')+$t('Bao.phone')"
              name="phone"
              :data-vv-as="$t('Bao.phone')"
              :only-countries="countryList"
              :default-country="defaultCountry"
              mode="international"
              :required="true"
              autocomplete="off"
            />
            <small v-if="errors.has('phone')" class="help-block">{{ errors.first('phone') }}</small>
          </div>
          <div v-if="$store.getters.permissionInfo.register_need_phone == 1" class="form-group">
            <label class="form_lab">
              <b>{{ $t('Bao.please_input') + $t("Bao.validateCode") }}</b>
            </label>
            <div class="verify_area d-grid">
              <span class="position-relative">
                <input
                  v-model="postForm.validateCode"
                  v-validate="'required'"
                  class="account_form_ipt text-center w-100"
                  :placeholder="$t('Bao.please_input')+$t('Bao.validateCode')"
                  type="text"
                  name="validateCode"
                  :data-vv-as="$t('Bao.validateCode')"
                >
                <small v-if="errors.has('validateCode')" class="help-block">{{ errors.first('validateCode') }}</small>
              </span>
              <button
                :disabled="limitVerify || gettingVerify"
                type="button"
                class="btn btn_login_other d-flex align-items-center justify-content-center"
                @click="getCode"
              >
                <i v-show="gettingVerify" class="fa fa-spinner fa-pulse fa-fw" />
                {{ limitVerify ? '(' + limitSecond + ')' : $t('Bao.get_verification_code') }}
              </button>
            </div>
          </div>
          <div class="form-group">
            <label class="form_lab">
              <b>{{ $t('Bao.promotion_invite_code') }}</b>
            </label>
            <input
              v-model="postForm.promotion_code"
              v-validate="'numeric'"
              class="account_form_ipt text-center w-100"
              :placeholder="$t('Bao.please_leave_blank_if_none')"
              type="text"
              name="promotion_code"
              :data-vv-as="$t('Bao.promotion_invite_code')"
              :readonly="isCodeReadOnly"
            >
            <small v-if="errors.has('promotion_code')" class="help-block">{{ errors.first('promotion_code') }}</small>
            <input
              v-model="postForm.track_code"
              v-validate="'numeric'"
              class="form_ipt form-control"
              type="hidden"
              name="track_code"
            >
          </div>
          <div class="form-group">
            <div class="d-grid justify-content-end">
              <p class="login_gray text-center mb-0">
                {{ $t("Bao.exist_account") }}
                <router-link to="/agent/member">
                  <a class="login_forget" href="#">
                    {{ $t("Bao.apply") }}
                  </a>
                </router-link>
              </p>
            </div>
          </div>
          <div class="form-group mt-40">
            <button
              class="btn btn_login w-100 border-0"
              type="button"
              :disabled="actionLoading"
              @click="handleUpdate"
            >
              <b>{{ $t("Bao.confirm") }}</b>
              <i v-show="actionLoading" class="fa fa-spinner fa-pulse fa-fw" />
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="login_bg" :style="{ backgroundImage: `url(${login_bg})` }" />
  </form>
</template>
<script>
import { VueTelInput } from 'vue-tel-input'
import { getPhoneCode, register, applyAgent } from '@/api/user'
import { showNotice, setErrorMessage } from '@/utils/tool'

export default {
  components: {
    VueTelInput
  },
  data() {
    const postForm = {
      username: null,
      newPassword: null,
      confirmPassword: null,
      phone: null,
      validateCode: null,
      promotion_code: null
    }
    const contactForm = {
      username: '',
      password: '',
      type: '',
      name: ''
    }
    return {
      actionLoading: false,
      postForm,
      contactForm,
      limitVerify: false,
      gettingVerify: false,
      limitSecond: 300,
      countryList: [],
      defaultCountry: '',
      contactTypes: {
        'Telegram': 'Telegram',
        'e-mail': 'e-mail',
        'Facebook': 'Facebook',
        'phone_number': 'Phone Number'
      },
      fieldTypes: {
        newPassword: 'text',
        confirmPassword: 'text'
      },
      login_bg: this.$store.state.brand.brandImage.agent_registration_banner !== undefined ? this.$store.state.brand.brandImage.agent_registration_banner[0].image : ''
    }
  },
  created() {
    const inviteCode = new URL(window.location.href || document.location.href).searchParams.get('code')
    if (inviteCode) {
      this.$store.commit('SET_INVITE_CODE', inviteCode)
      this.postForm.promotion_code = inviteCode
    }

    this.countryList = this.$store.getters.supportPhoneCode
    this.defaultCountry = this.countryList[0]
  },
  methods: {
    getCode() {
      this.gettingVerify = true
      getPhoneCode({ phone: this.postForm.phone }).then(response => {
        showNotice(response.data.msg)
        this.countDown()
        this.gettingVerify = false
      }).catch((error) => {
        showNotice(error.response.data.msg)
        this.gettingVerify = false
      })
    },
    countDown() {
      this.limitVerify = true
      this.limitSecond = 300
      const clock = window.setInterval(() => {
        this.limitSecond--
        if (this.limitSecond < 0) {
          this.limitVerify = false
          window.clearInterval(clock)
        }
      }, 1000)
    },
    handleReset() {
      this.postForm = Object.assign({}, this.defaultForm)
      this.contactForm = Object.assign({}, this.defaultForm)
    },
    handleUpdate() {
      const self = this

      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.actionLoading = true
          register(this.postForm).then(response => {
            this.contactForm.username = this.postForm.username
            this.contactForm.password = this.postForm.newPassword
            applyAgent(this.contactForm).then(response => {
              showNotice(response.data.data.msg, function() {
                self.$router.push({ path: '/index' })
              })
            }).catch((error) => {
              showNotice(error.response.data.msg)
            }).finally((e) => {
              this.actionLoading = false
            })
          }).catch((error) => {
            setErrorMessage(error.response, this.errors)
          }).finally((e) => {
            this.actionLoading = false
          })
        }
      })
    },
    handleType(event) {
      const { srcElement, type } = event
      const { name, value } = srcElement
      if (type === 'blur' && !value) {
        this.fieldTypes[name] = 'text'
      } else {
        this.fieldTypes[name] = 'password'
      }
    }
  }
}
</script>

<style scoped>
.custom-vue-tel-input input{
  color: red;
  border-radius: 15px;
}
</style>
